import {
  Icon,
  IconButton,
  OutlinedTextFieldProps,
  TextField,
} from '@mui/material'
import React from 'react'

type Props = {
  value: string
  onChangeValue: (value: string) => void
}

function SearchInput({ value, onChangeValue }: Props) {
  const handleChange: OutlinedTextFieldProps['onChange'] = (e) => {
    onChangeValue(e.target.value)
  }
  return (
    <TextField
      style={{ width: '100%', color: 'white' }}
      variant="outlined"
      size="small"
      value={value}
      onChange={handleChange}
      placeholder="Search users..."
      InputProps={{
        startAdornment: (
          <Icon className="mr-3" fontSize="small">
            search
          </Icon>
        ),
        endAdornment: value && (
          <IconButton size="small" onClick={() => onChangeValue('')}>
            <Icon fontSize="small">clear</Icon>
          </IconButton>
        ),
      }}
    />
  )
}

export default SearchInput
